/**
 * Created by akrio on 2018/4/29.
 */
import ToastComponent from "../../components/toast/Index";
import LoadingComponent from "../../components/toast/Loading";

export function createToastVM(Vue) {
  const Toast = Vue.extend(ToastComponent);
  const $toastVm = new Toast({
    el: document.createElement("div"),
  });
  document.body.appendChild($toastVm.$el);
  return $toastVm;
}

export function createLoadingVM(Vue) {
  const Loading = Vue.extend(LoadingComponent);
  const $loadingVm = new Loading({
    el: document.createElement("div"),
  });
  document.body.appendChild($loadingVm.$el);
  return $loadingVm;
}

let $toastVm;
let $loadingVm;
/**
 * 信息提示框
 */
export const ToastPlugin = {
  install(Vue) {
    if (!$toastVm) {
      $toastVm = createToastVM(Vue);
    }
    const toast = {
      show({ message = "", type = "success", size = 16 }) {
        $toastVm.message = message;
        $toastVm.type = type;
        $toastVm.size = size;
        $toastVm.showModal = true;
      },
      hide() {
        $toastVm.showModal = false;
      },
    };
    Vue.mixin({
      created() {
        this.$toast = toast;
      },
    });
  },
};

/**
 * 加载样式弹出框
 */
export const LoadingPlugin = {
  install(Vue) {
    if (!$loadingVm) {
      $loadingVm = createLoadingVM(Vue);
    }

    const loading = {
      show() {
        $loadingVm.showModal = true;
      },
      hide() {
        $loadingVm.showModal = false;
      },
    };
    Vue.mixin({
      created() {
        this.$loading = loading;
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugins/toast/index.js